.title {
	composes: title-1 from global;
	margin-bottom: 4px;
}
